export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime */
  DateTimeUtc: any;
  /** NaiveDate */
  NaiveDate: any;
  /** NaiveDateTime */
  NaiveDateTime: any;
};

export enum AccountAvailability {
  AVAILABLE = 'AVAILABLE',
  MISMATCH = 'MISMATCH',
  UNAVAILABLE = 'UNAVAILABLE',
}

export type ActiveSettlementMethod = {
  __typename?: 'ActiveSettlementMethod';
  billStatementState: BillStatementState;
  billingCycle: Scalars['String'];
  settlementMethods: SettlementMethods;
};

export type ActiveSettlementMethodChange = {
  __typename?: 'ActiveSettlementMethodChange';
  result: SettlementMethodStatusChangeResult;
  state: ActiveSettlementMethod;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export enum AppleCreditLimitUpgradeStatus {
  APPROVED = 'APPROVED',
  AWAITING_CIC_RESULTS = 'AWAITING_CIC_RESULTS',
  AWAITING_PAC_ASSESSMENT = 'AWAITING_PAC_ASSESSMENT',
  CANCELED = 'CANCELED',
  NEVER_STARTED = 'NEVER_STARTED',
  PAC_DATA_REQUIRED = 'PAC_DATA_REQUIRED',
  REJECTED = 'REJECTED',
}

export type AppleCreditLimitUpgradeStatusResponse = {
  __typename?: 'AppleCreditLimitUpgradeStatusResponse';
  status: AppleCreditLimitUpgradeStatus;
};

export enum AppleCreditStatus {
  APPROVED = 'APPROVED',
  AWAITING_CIC_RESULTS = 'AWAITING_CIC_RESULTS',
  AWAITING_PAC_ASSESSMENT = 'AWAITING_PAC_ASSESSMENT',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  NEVER_STARTED = 'NEVER_STARTED',
  PAC_DATA_REQUIRED = 'PAC_DATA_REQUIRED',
  REJECTED = 'REJECTED',
}

export enum AppleCreditStatusDetails {
  AWAITING_CIC_RESULTS_CIC_CLOSED = 'AWAITING_CIC_RESULTS_CIC_CLOSED',
}

export type AppleCreditStatusResponse = {
  __typename?: 'AppleCreditStatusResponse';
  status: AppleCreditStatus;
  statusDetails?: Maybe<AppleCreditStatusDetails>;
};

export enum AuthVerificationScope {
  APP_PII_UNMASK = 'APP_PII_UNMASK',
  UPDATE_CONSUMER_INFO = 'UPDATE_CONSUMER_INFO',
}

export type AutoDebitAccount = {
  __typename?: 'AutoDebitAccount';
  bankCode: Scalars['String'];
  bankName: Scalars['String'];
  branchCode: Scalars['String'];
  kind: AutoDebitAccountKind;
  name: Scalars['String'];
  number: Scalars['String'];
};

export enum AutoDebitAccountKind {
  CURRENT = 'CURRENT',
  OTHER = 'OTHER',
  SAVINGS = 'SAVINGS',
}

export type AutoDebitResponse = {
  __typename?: 'AutoDebitResponse';
  account?: Maybe<AutoDebitAccount>;
  id: Scalars['String'];
  kfrequest?: Maybe<Scalars['String']>;
  status: AutoDebitStatus;
};

export type AutoDebitSettlement = {
  __typename?: 'AutoDebitSettlement';
  pullAmount: Scalars['Float'];
  pullStatus: AutoDebitSettlementStatus;
  resultsProcessedBy: Scalars['DateTimeUtc'];
};

export type AutoDebitSettlementMethod = {
  __typename?: 'AutoDebitSettlementMethod';
  accountAvailability: AccountAvailability;
  nextAutoDebitByDate: Scalars['String'];
  nextPullDate: Scalars['String'];
  status: AutoDebitSettlementMethodStatus;
};

export enum AutoDebitSettlementMethodStatus {
  ACTIVE = 'ACTIVE',
  APPLIED = 'APPLIED',
  INACTIVE = 'INACTIVE',
  NOT_REGISTERED = 'NOT_REGISTERED',
  PENDING = 'PENDING',
}

export enum AutoDebitSettlementStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

export enum AutoDebitStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  SUSPENDED = 'SUSPENDED',
}

export type AvailableInstallmentPlanOptions = {
  __typename?: 'AvailableInstallmentPlanOptions';
  amount: Scalars['Float'];
  currency: Currency;
  installments: Array<Installment>;
  kind: InstallmentPlanKind;
};

export type BalanceRatiosPlus = {
  __typename?: 'BalanceRatiosPlus';
  monthlyPowerRatio: Scalars['Float'];
  nextMonthDueRatio: Scalars['Float'];
};

export type BillStatement = {
  __typename?: 'BillStatement';
  amount: Scalars['Float'];
  autoDebitSettlement?: Maybe<AutoDebitSettlement>;
  bankTransferSettlementAvailable: Scalars['Boolean'];
  billingCycle: Scalars['String'];
  charges: Array<Charge>;
  combiniSettlementAvailable: Scalars['Boolean'];
  currency: Currency;
  dueAt: Scalars['DateTimeUtc'];
  id: Scalars['String'];
  lateFeeAmount: Scalars['Float'];
  lateFeeCharges: Array<Charge>;
  outstandingAmount: Scalars['Float'];
  paidAt?: Maybe<Scalars['DateTimeUtc']>;
  period: Period;
  spentAmount?: Maybe<Scalars['Float']>;
  status: BillStatementStatus;
  statusV2: BillStatementStatusV2;
  totalCredits: Scalars['Float'];
  unpaidAmount: Scalars['Float'];
  unpaidAmountActual: Scalars['Float'];
};

export type BillStatementState = {
  __typename?: 'BillStatementState';
  status: BillStatementStateStatus;
};

export enum BillStatementStateStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  OUTSTANDING = 'OUTSTANDING',
  OVERDUE = 'OVERDUE',
}

export enum BillStatementStatus {
  CREATED = 'CREATED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
}

export enum BillStatementStatusV2 {
  OUTSTANDING = 'OUTSTANDING',
  OUTSTANDING_FAILED_AD = 'OUTSTANDING_FAILED_AD',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
}

export type CardEligibilityInfo = {
  __typename?: 'CardEligibilityInfo';
  hadVirtualCard: Scalars['Boolean'];
  hasAppliedForVirtualCard: Scalars['Boolean'];
  isEligibleForVirtualCard: Scalars['Boolean'];
};

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Float'];
  currency: Currency;
  description: Scalars['String'];
  id: Scalars['String'];
  installmentPlanOptions?: Maybe<InstallmentPlanOptions>;
  isPayNowSettlement: Scalars['Boolean'];
  isVanTransferSettlement?: Maybe<Scalars['Boolean']>;
  kind: ChargeKind;
  metadata: ChargeMetadata;
  multipayPayment?: Maybe<Payment>;
  paidBillingCycle?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  pushedAt: Scalars['DateTimeUtc'];
  tier: Tier;
};

export enum ChargeKind {
  CAPTURE = 'CAPTURE',
  CASHBACK = 'CASHBACK',
  LATE_FEE = 'LATE_FEE',
  MANUAL_CREDIT = 'MANUAL_CREDIT',
  MANUAL_DEBIT = 'MANUAL_DEBIT',
  MULTI_PAY_CREDIT = 'MULTI_PAY_CREDIT',
  MULTI_PAY_DEBIT = 'MULTI_PAY_DEBIT',
  REFUND = 'REFUND',
  SETTLEMENT = 'SETTLEMENT',
}

export type ChargeMetadata = {
  __typename?: 'ChargeMetadata';
  appleClawbackType?: Maybe<Scalars['String']>;
  byWayOf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeUtc'];
  installmentPlanChargeKind?: Maybe<Scalars['String']>;
  settlementFeeAmount?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  transactionItemId?: Maybe<Scalars['String']>;
};

export enum ClawbackType {
  CARRIER_DISCOUNT = 'CARRIER_DISCOUNT',
}

export type Code = {
  __typename?: 'Code';
  consumerCode: Scalars['String'];
  merchantCode: Scalars['String'];
  store: Scalars['String'];
};

export type Consumer = {
  __typename?: 'Consumer';
  address?: Maybe<Address>;
  consumerInfo: ConsumerInfo;
  dateOfBirth?: Maybe<Scalars['NaiveDate']>;
  email: Scalars['String'];
  externalConsumerIds: ConsumerExternalId;
  name1?: Maybe<Scalars['String']>;
  name2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  status: ConsumerStatus;
};

export type ConsumerBalanceSummary = {
  __typename?: 'ConsumerBalanceSummary';
  billingCycle: Scalars['String'];
  consumerLimits: ConsumerLimits;
  summaryPlus: SummaryPlus;
};

export type ConsumerExternalId = {
  __typename?: 'ConsumerExternalId';
  notifications: Scalars['String'];
  tracking: Scalars['String'];
};

export type ConsumerInfo = {
  __typename?: 'ConsumerInfo';
  cardEligibilityInfo: CardEligibilityInfo;
};

export type ConsumerLimits = {
  __typename?: 'ConsumerLimits';
  nmdLimit: Scalars['Float'];
  treLimit: Scalars['Float'];
};

export enum ConsumerStatus {
  CLOSED = 'CLOSED',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type ConsumerUsageSummary = {
  __typename?: 'ConsumerUsageSummary';
  isPayNowAvailable: Scalars['Boolean'];
  monthlyChargesBreakdown: Array<MonthlyCharges>;
  monthlyTotalUsages: Array<TotalMonthUsage>;
  monthlyTotalUsagesV3: Array<TotalMonthUsage>;
  outstandingDebts: OutstandingDebts;
  payableAmount: PayableAmount;
  plusCharges: Array<Charge>;
  recentDebits: Array<Charge>;
  recentSettlements: Array<Charge>;
  totalUsageAmount: Scalars['Float'];
  uncapturedAmount: Scalars['Float'];
  uncapturedPayments: Array<Payment>;
};

export type CreateKYCApplicationRequest = {
  address: KYCAddress;
  dateOfBirth: Scalars['NaiveDate'];
  firstName: Scalars['String'];
  firstNameKana: Scalars['String'];
  idDocumentType?: InputMaybe<KycIdDocumentType>;
  lastName: Scalars['String'];
  lastNameKana: Scalars['String'];
  profession: Profession;
  purpose: Purpose;
  referrer?: InputMaybe<Scalars['String']>;
  referrerChannel?: InputMaybe<Scalars['String']>;
};

export type CreateKYCApplicationResponse = {
  __typename?: 'CreateKYCApplicationResponse';
  url: Scalars['String'];
};

export type CreateKYCUpdateApplicationRequest = {
  address: KYCAddress;
  firstName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastName: Scalars['String'];
  lastNameKana: Scalars['String'];
};

export type CreateLiquidSdkApplicationResponse = {
  __typename?: 'CreateLiquidSdkApplicationResponse';
  applicantId: Scalars['String'];
  token: Scalars['String'];
};

export type CreditLimit = {
  __typename?: 'CreditLimit';
  creditLimit: Scalars['Float'];
  kind: CreditLimitKind;
  outstandingDebt: Scalars['Float'];
  remainingLimit: Scalars['Float'];
};

export enum CreditLimitKind {
  APPLE = 'APPLE',
  PAIDY_PLUS = 'PAIDY_PLUS',
}

export enum CreditLimitUpgradeStatus {
  APPROVED = 'APPROVED',
  AWAITING_CIC_RESULTS = 'AWAITING_CIC_RESULTS',
  AWAITING_PAC_ASSESSMENT = 'AWAITING_PAC_ASSESSMENT',
  CANCELED = 'CANCELED',
  NEVER_STARTED = 'NEVER_STARTED',
  PAC_DATA_REQUIRED = 'PAC_DATA_REQUIRED',
  REJECTED = 'REJECTED',
}

export type CreditLimitUpgradeStatusResponse = {
  __typename?: 'CreditLimitUpgradeStatusResponse';
  status: CreditLimitUpgradeStatus;
};

export enum Currency {
  JPY = 'JPY',
  USD = 'USD',
}

export enum DesiredSettlementMethod {
  AUTO_DEBIT = 'AUTO_DEBIT',
  COMBINI_OR_VAN = 'COMBINI_OR_VAN',
}

export type DeviceInfo = {
  deviceName: Scalars['String'];
  osVersion: Scalars['String'];
  screenHeight: Scalars['Int'];
  screenWidth: Scalars['Int'];
  xDpi?: InputMaybe<Scalars['Int']>;
  yDpi?: InputMaybe<Scalars['Int']>;
};

export type FeatureWithVariant = {
  __typename?: 'FeatureWithVariant';
  name: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type Features = {
  __typename?: 'Features';
  enabled: Array<Scalars['String']>;
};

export type FeaturesWithVariants = {
  __typename?: 'FeaturesWithVariants';
  enabled: Array<FeatureWithVariant>;
};

export enum HoukatsuStatus {
  APPROVED = 'APPROVED',
  APPROVED_FOR_NLP = 'APPROVED_FOR_NLP',
  AWAITING_CIC_RESULTS = 'AWAITING_CIC_RESULTS',
  AWAITING_PAC_ASSESSMENT = 'AWAITING_PAC_ASSESSMENT',
  CANCELED = 'CANCELED',
  CAN_REAPPLY = 'CAN_REAPPLY',
  CLOSED = 'CLOSED',
  NEVER_STARTED = 'NEVER_STARTED',
  NOT_PEP_DECLARED = 'NOT_PEP_DECLARED',
  PAC_DATA_REQUIRED = 'PAC_DATA_REQUIRED',
  REJECTED = 'REJECTED',
}

export type HoukatsuStatusResponse = {
  __typename?: 'HoukatsuStatusResponse';
  status: HoukatsuStatus;
};

export type InputAddress = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type Installment = {
  __typename?: 'Installment';
  amount: Scalars['Float'];
  dueDate: Scalars['DateTimeUtc'];
  dueNext: Scalars['Boolean'];
  id: Scalars['String'];
  number: Scalars['Int'];
};

export type InstallmentPlan = {
  __typename?: 'InstallmentPlan';
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  currency: Currency;
  id: Scalars['String'];
  installments: Array<Installment>;
  kind: InstallmentPlanKind;
  payment?: Maybe<Payment>;
  status: InstallmentPlanStatus;
};

export enum InstallmentPlanKind {
  APPLE3_MONTHS = 'APPLE3_MONTHS',
  APPLE6_MONTHS = 'APPLE6_MONTHS',
  APPLE12_MONTHS = 'APPLE12_MONTHS',
  APPLE24_MONTHS = 'APPLE24_MONTHS',
  APPLE36_MONTHS = 'APPLE36_MONTHS',
  APPLE48_MONTHS = 'APPLE48_MONTHS',
  SIX_PAY = 'SIX_PAY',
  THREE_PAY = 'THREE_PAY',
  TWELVE_PAY = 'TWELVE_PAY',
}

export type InstallmentPlanOptions = {
  __typename?: 'InstallmentPlanOptions';
  available: Array<AvailableInstallmentPlanOptions>;
  unavailable: Array<UnavailableInstallmentPlanOptions>;
};

export enum InstallmentPlanStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
}

export enum ItemKind {
  CLAWBACK = 'CLAWBACK',
  SALE = 'SALE',
}

export type KYCAddress = {
  city: Scalars['String'];
  line1?: InputMaybe<Scalars['String']>;
  line2: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type KYCApplicationDetailsResponse = {
  __typename?: 'KYCApplicationDetailsResponse';
  address: Address;
  firstName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastName: Scalars['String'];
  lastNameKana: Scalars['String'];
  profession: Profession;
  purpose: Purpose;
  timestampUtc: Scalars['String'];
};

export enum KYCStatus {
  APPROVED = 'APPROVED',
  NEVER_APPLIED = 'NEVER_APPLIED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type KYCStatusResponse = {
  __typename?: 'KYCStatusResponse';
  status: KYCStatus;
};

export enum KYCUpdateStatus {
  APPROVED = 'APPROVED',
  NEVER_STARTED = 'NEVER_STARTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
}

export type KYCUpdateStatusResponse = {
  __typename?: 'KYCUpdateStatusResponse';
  status: KYCUpdateStatus;
};

export enum KycIdDocumentType {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  MY_NUMBER = 'MY_NUMBER',
}

export type KycOcrResultsResponse = {
  __typename?: 'KycOcrResultsResponse';
  address?: Maybe<Scalars['String']>;
  addressCity?: Maybe<Scalars['String']>;
  addressOther?: Maybe<Scalars['String']>;
  addressPref?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  expireDate?: Maybe<Scalars['String']>;
  idDocumentType: Scalars['String'];
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type KycWebApplicationCreatedResponse = {
  __typename?: 'KycWebApplicationCreatedResponse';
  applicantId: Scalars['String'];
  applicationUrl: Scalars['String'];
};

export enum MessagingHubPushNotificationCategory {
  GENERAL = 'GENERAL',
  OPEN_LOOP_USAGE = 'OPEN_LOOP_USAGE',
}

export type MonthlyCharges = {
  __typename?: 'MonthlyCharges';
  billingCycle: Scalars['String'];
  charges: Array<Charge>;
};

export type MultiPayConfiguration = {
  __typename?: 'MultiPayConfiguration';
  merchantId: Scalars['String'];
  perKind: Array<XPayKind>;
};

export type MultipayContract = {
  __typename?: 'MultipayContract';
  approvalDecisionAt?: Maybe<Scalars['DateTimeUtc']>;
  charges: Array<MultipayContractCharge>;
  contractFee: Scalars['Float'];
  contractFeeRate: Scalars['Float'];
  currency: Currency;
  id: Scalars['String'];
  principal: Scalars['Float'];
  status: MultipayContractStatus;
};

export type MultipayContractCharge = {
  __typename?: 'MultipayContractCharge';
  currency: Currency;
  fee: Scalars['Float'];
  id: Scalars['String'];
  isPushed: Scalars['Boolean'];
  order: Scalars['Int'];
  principal: Scalars['Float'];
  pushAt: Scalars['DateTimeUtc'];
};

export enum MultipayContractStatus {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Approve trasaction by transaction id */
  approveTransaction: TransactionStatusResponse;
  /** Cancel trasaction by transaction id */
  cancelTransaction: TransactionStatusResponse;
  /** Close user account */
  closeAccount: Scalars['Boolean'];
  /** Perform and conclude authentication verification */
  confirmAuthVerification: Scalars['Boolean'];
  /** Confirm email reset */
  confirmResetEmail: Scalars['Boolean'];
  /** Confirm phone number reset */
  confirmResetPhoneNumber: Scalars['Boolean'];
  /** Create auto debit registration */
  createAutoDebitRegistration: AutoDebitResponse;
  /** Create an installment plan */
  createInstallmentPlan: InstallmentPlan;
  /** Create a KYC application for a consumer */
  createKYCApplication: CreateKYCApplicationResponse;
  createKYCWebApplication: KycWebApplicationCreatedResponse;
  /** Create a KYC Liquid SDK application for a consumer */
  createLiquidSdkApplication: CreateLiquidSdkApplicationResponse;
  /** Create a KYC Liquid SDK update application for a consumer */
  createLiquidSdkUpdateApplication: CreateLiquidSdkApplicationResponse;
  /** Create a settlement using Paysle for paynow */
  createPaynowBarcodeV3: PaysleSettlement;
  /** Create a settlement using Paygent for paynow */
  createPaynowNumericCodeV3: PaygentSettlement;
  /** Create a settlement using Paysle for single bill */
  createSinglebillBarcodeV3: PaysleSettlement;
  /** Create a settlement using Paygent */
  createSinglebillNumericCodeV3: PaygentSettlement;
  /** Delete a consumer's auto debit registration */
  deleteAutoDebitRegistration: AutoDebitResponse;
  /** Conclude email reset flow */
  doResetEmail: Scalars['Boolean'];
  /** Conclude phone number reset flow */
  doResetPhoneNumber: Scalars['Boolean'];
  /** Initiate authentication verification by sending an OTP */
  initiateAuthVerification: Scalars['Boolean'];
  /** Initate email reset flow */
  initiateResetEmail: Scalars['Boolean'];
  /** Initiate phone number reset flow */
  initiateResetPhoneNumber: Scalars['Boolean'];
  /** Initiate verify email */
  initiateVerifyEmail: Scalars['Boolean'];
  /** Delete a consumer's login session */
  logout: Scalars['Boolean'];
  /** Apply for Apple credit */
  optInAppleCredit: AppleCreditStatusResponse;
  /** Submit KYC application to Liquid */
  registerLiquidApplicationInfo: Ok;
  /** Submit KYC update application to Liquid */
  registerLiquidUpdateApplicationInfo: Ok;
  /** Register notification id in the sms and voice service */
  registerNotificationId: Scalars['Boolean'];
  /** Reset a consumer's email address */
  resetEmail: Scalars['Boolean'];
  /** Reset a consumer's phone */
  resetPhone: Scalars['Boolean'];
  /** Resume a consumer's auto debit registration */
  resumeAutoDebitRegistration: AutoDebitResponse;
  /**
   * Send an email to the authenticated consumer with category and substitutions based on the
   * email type.
   */
  sendSelfEmail: Scalars['Boolean'];
  /** billingCycle can be YYYY-MM or `current` */
  setDesiredActiveSettlementMethod: ActiveSettlementMethodChange;
  /** Set a consumer's Payment Ability Check (PAC) data */
  setPACData: Scalars['Boolean'];
  /** Set a consumer's Politically Exposed Person (PEP) status */
  setPEPStatus: Scalars['Boolean'];
  /** Set Push notifications settings for consumer */
  setPushNotificationsByConsumer: PushPreferencesResponse;
  /** Set Push notifications settings for category */
  setPushNotificationsByConsumerAndCategory: UpdatePushPreferenceResponse;
  /** Set a consumer's spend limit */
  setSpendLimit: SpendLimit;
  signOut: Scalars['Boolean'];
  /** Suspend a consumer's auto debit registration */
  suspendAutoDebitRegistration: AutoDebitResponse;
  /** Update consumer info */
  updateConsumer: Consumer;
};

export type MutationapproveTransactionArgs = {
  id: Scalars['String'];
};

export type MutationcancelTransactionArgs = {
  id: Scalars['String'];
};

export type MutationcloseAccountArgs = {
  reason?: InputMaybe<Scalars['String']>;
};

export type MutationconfirmAuthVerificationArgs = {
  otp: Scalars['String'];
  scope: AuthVerificationScope;
};

export type MutationconfirmResetEmailArgs = {
  otp: Scalars['String'];
};

export type MutationconfirmResetPhoneNumberArgs = {
  otp: Scalars['String'];
  pinCodeDispatchMethod?: InputMaybe<PinCodeDispatchMethod>;
};

export type MutationcreateAutoDebitRegistrationArgs = {
  dateOfBirth: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type MutationcreateInstallmentPlanArgs = {
  chargeId: Scalars['String'];
  kind?: InputMaybe<InstallmentPlanKind>;
};

export type MutationcreateKYCApplicationArgs = {
  data: CreateKYCApplicationRequest;
};

export type MutationcreateKYCWebApplicationArgs = {
  idDocumentType?: InputMaybe<KycIdDocumentType>;
};

export type MutationcreatePaynowBarcodeV3Args = {
  combiniFee: Scalars['Float'];
  cvsStoreId: Scalars['String'];
  deviceInfo: DeviceInfo;
  payableAmount: Scalars['Float'];
  referenceIds: ReferenceIds;
};

export type MutationcreatePaynowNumericCodeV3Args = {
  combiniFee: Scalars['Float'];
  cvsStoreId: Scalars['String'];
  payableAmount: Scalars['Float'];
  referenceIds: ReferenceIds;
};

export type MutationcreateSinglebillBarcodeV3Args = {
  billId: Scalars['String'];
  cvsStoreId: Scalars['String'];
  deviceInfo: DeviceInfo;
};

export type MutationcreateSinglebillNumericCodeV3Args = {
  billId: Scalars['String'];
  cvsStoreId: Scalars['String'];
};

export type MutationdeleteAutoDebitRegistrationArgs = {
  id: Scalars['String'];
};

export type MutationdoResetEmailArgs = {
  otp: Scalars['String'];
};

export type MutationdoResetPhoneNumberArgs = {
  otp: Scalars['String'];
};

export type MutationinitiateAuthVerificationArgs = {
  pinCodeDispatchMethod?: InputMaybe<PinCodeDispatchMethod>;
  scope: AuthVerificationScope;
};

export type MutationinitiateResetEmailArgs = {
  newEmail: Scalars['String'];
  pinCodeDispatchMethod?: InputMaybe<PinCodeDispatchMethod>;
};

export type MutationinitiateResetPhoneNumberArgs = {
  newPhoneNumber: Scalars['String'];
};

export type MutationlogoutArgs = {
  token: Scalars['String'];
};

export type MutationregisterLiquidApplicationInfoArgs = {
  data: CreateKYCApplicationRequest;
};

export type MutationregisterLiquidUpdateApplicationInfoArgs = {
  data: CreateKYCUpdateApplicationRequest;
};

export type MutationregisterNotificationIdArgs = {
  externalConsumerId: Scalars['String'];
};

export type MutationresetEmailArgs = {
  email: Scalars['String'];
};

export type MutationresumeAutoDebitRegistrationArgs = {
  id: Scalars['String'];
};

export type MutationsendSelfEmailArgs = {
  emailType: SelfEmailType;
};

export type MutationsetDesiredActiveSettlementMethodArgs = {
  billingCycle: Scalars['String'];
  desiredSettlementMethod: DesiredSettlementMethod;
};

export type MutationsetPACDataArgs = {
  numberOfDependents: NumberOfDependents;
  rentOrMortgage: RentOrMortgage;
  salary: Scalars['Int'];
};

export type MutationsetPEPStatusArgs = {
  isExposed: Scalars['Boolean'];
};

export type MutationsetPushNotificationsByConsumerArgs = {
  preferences: PushPreferences;
};

export type MutationsetPushNotificationsByConsumerAndCategoryArgs = {
  category: MessagingHubPushNotificationCategory;
  enabled: Scalars['Boolean'];
};

export type MutationsetSpendLimitArgs = {
  selected: Scalars['Float'];
};

export type MutationsuspendAutoDebitRegistrationArgs = {
  id: Scalars['String'];
};

export type MutationupdateConsumerArgs = {
  address?: InputMaybe<InputAddress>;
  dateOfBirth?: InputMaybe<Scalars['NaiveDate']>;
  email?: InputMaybe<Scalars['String']>;
  name1?: InputMaybe<Scalars['String']>;
  name2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum NLPMigrationStatus {
  APPROVED = 'APPROVED',
  AWAITING_CIC_RESULTS = 'AWAITING_CIC_RESULTS',
  AWAITING_PAC_ASSESSMENT = 'AWAITING_PAC_ASSESSMENT',
  CANCELED = 'CANCELED',
  NEVER_STARTED = 'NEVER_STARTED',
  PAC_DATA_REQUIRED = 'PAC_DATA_REQUIRED',
  REJECTED = 'REJECTED',
}

export type NLPMigrationStatusResponse = {
  __typename?: 'NLPMigrationStatusResponse';
  status: NLPMigrationStatus;
};

export enum NumberOfDependents {
  ONE = 'ONE',
  THREE_OR_MORE = 'THREE_OR_MORE',
  TWO = 'TWO',
  ZERO = 'ZERO',
}

/** Generic response where no response is expected to be returned, typically set to true */
export type Ok = {
  __typename?: 'Ok';
  ok: Scalars['Boolean'];
};

export type OutstandingDebts = {
  __typename?: 'OutstandingDebts';
  apple?: Maybe<Scalars['Float']>;
  paidyPlus?: Maybe<Scalars['Float']>;
};

export type OverdueBillStatement = {
  __typename?: 'OverdueBillStatement';
  billStatementId: Scalars['String'];
  billingCycle: Scalars['String'];
  dueAt: Scalars['DateTimeUtc'];
  overdueAmount: Scalars['Float'];
};

export type PEPStatusResponse = {
  __typename?: 'PEPStatusResponse';
  isExposed?: Maybe<Scalars['Boolean']>;
};

export type PaidOverdueBillStatement = {
  __typename?: 'PaidOverdueBillStatement';
  billStatementId: Scalars['String'];
  billingCycle: Scalars['String'];
  dueAt: Scalars['DateTimeUtc'];
  paidAmount: Scalars['Float'];
};

export type PayableAmount = {
  __typename?: 'PayableAmount';
  at: Scalars['DateTimeUtc'];
  payableAmount: Scalars['Float'];
};

export type PaygentSettlement = {
  __typename?: 'PaygentSettlement';
  amount: Scalars['Float'];
  codes: Code;
  currency: Currency;
  settlementFeeAmount?: Maybe<Scalars['Float']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float'];
  byWayOf?: Maybe<Scalars['String']>;
  captureIds?: Maybe<Array<Scalars['String']>>;
  capturedAmount: Scalars['Float'];
  createdAt: Scalars['DateTimeUtc'];
  currency: Currency;
  id: Scalars['String'];
  installmentPlanKind?: Maybe<InstallmentPlanKind>;
  order: PaymentOrder;
  orderId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  storeName?: Maybe<Scalars['String']>;
  subMerchantId?: Maybe<Scalars['String']>;
  tier: Tier;
};

export type PaymentItem = {
  __typename?: 'PaymentItem';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  items: Array<PaymentItem>;
  shipping?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

export enum PaymentStatus {
  AUTHORIZED = 'AUTHORIZED',
  CLOSED = 'CLOSED',
  PENDING = 'PENDING',
}

export type PaysleSettlement = {
  __typename?: 'PaysleSettlement';
  amount: Scalars['Float'];
  barcodeData: Scalars['String'];
  currency: Currency;
  imgFormat: Scalars['String'];
  imgH: Scalars['Int'];
  imgW: Scalars['Int'];
  settlementFeeAmount?: Maybe<Scalars['Float']>;
};

export type Period = {
  __typename?: 'Period';
  end: Scalars['DateTimeUtc'];
  start: Scalars['DateTimeUtc'];
};

export enum PinCodeDispatchMethod {
  SMS = 'SMS',
  VOICE = 'VOICE',
}

export type PlusContract = {
  __typename?: 'PlusContract';
  amount: Scalars['Float'];
  contractedAt?: Maybe<Scalars['DateTimeUtc']>;
  createdAt: Scalars['DateTimeUtc'];
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTimeUtc']>;
  id: Scalars['String'];
  status: PlusContractStatus;
};

export enum PlusContractStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
}

export enum Profession {
  CIVIL_OFFICER = 'CIVIL_OFFICER',
  EMPLOYEE = 'EMPLOYEE',
  EXECUTIVE = 'EXECUTIVE',
  HOUSEWIFE = 'HOUSEWIFE',
  PART_TIME = 'PART_TIME',
  PENSIONER = 'PENSIONER',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  STUDENT = 'STUDENT',
  TEMPORARY = 'TEMPORARY',
  UNEMPLOYED = 'UNEMPLOYED',
}

export enum Purpose {
  BUSINESS = 'BUSINESS',
  PAYMENT = 'PAYMENT',
  SHOPPING = 'SHOPPING',
}

export type PushPreference = {
  category: MessagingHubPushNotificationCategory;
  enabled: Scalars['Boolean'];
};

export type PushPreferenceResponse = {
  __typename?: 'PushPreferenceResponse';
  category: MessagingHubPushNotificationCategory;
  enabled: Scalars['Boolean'];
};

export type PushPreferences = {
  categories: Array<PushPreference>;
};

export type PushPreferencesResponse = {
  __typename?: 'PushPreferencesResponse';
  categories: Array<PushPreferenceResponse>;
};

export type Query = {
  __typename?: 'Query';
  /** Get the status of a consumer's apple credit limit upgrade */
  AppleCreditLimitUpgradeStatus: AppleCreditLimitUpgradeStatusResponse;
  /** Get the status of a consumer's credit limit upgrade */
  CreditLimitUpgradeStatus: CreditLimitUpgradeStatusResponse;
  /** Get the details of a consumer’s KYC application */
  KYCApplicationDetails: KYCApplicationDetailsResponse;
  /** Get the status of a consumer's KYC application */
  KYCApplicationStatus: KYCStatusResponse;
  KYCOCRResults: KycOcrResultsResponse;
  /** Get the status of a consumer's KYC update application */
  KYCUpdateApplicationStatus: KYCUpdateStatusResponse;
  /** Get the status of a consumer's NLP migration */
  NLPMigrationStatus: NLPMigrationStatusResponse;
  /** Get a consumer's Politically Exposed Person (PEP) status */
  PEPStatus: PEPStatusResponse;
  /** Get VAN registered to consumer else register a new VAN */
  VAN: VAN;
  /** Get active settlement method */
  activeSettlementMethod: ActiveSettlementMethod;
  /** Get the status of a consumer's Apple application */
  appleCreditStatus: AppleCreditStatusResponse;
  /** Get the consumer's auto debit registration */
  autoDebitRegistration: AutoDebitResponse;
  /** Get a bill statement by bill id */
  billStatement: BillStatement;
  /** Get a list of the consumer's bill statements */
  billStatements: Array<BillStatement>;
  /**
   * Get a consumer`s charge by id
   * NOTE: This cannot have a `payment` subquery since there is no payments/captures map generated
   */
  charge: Charge;
  /** Get a list of the consumer's charges */
  charges: Array<Charge>;
  /** Get consumer info by id */
  consumer: Consumer;
  /** Get nlp data */
  consumerBalanceSummary: ConsumerBalanceSummary;
  /** Get consumer usage summary */
  consumerUsageSummary: ConsumerUsageSummary;
  /** Get a consumer's credit limit */
  creditLimit?: Maybe<CreditLimit>;
  /** Get available credit limits */
  creditLimits: Array<CreditLimit>;
  /** Get features enabled for consumer */
  features: Features;
  /** Get features with variants enabled for consumer */
  featuresWithVariants: FeaturesWithVariants;
  /** Get Push Notification Settings */
  getPushNotifications: PushPreferencesResponse;
  /** Get the status of a consumer's Houkatsu application */
  houkatsuStatus: HoukatsuStatusResponse;
  /** Get a consumer's installment plan by ID */
  installmentPlan: InstallmentPlan;
  /** Get a consumer's installment plans */
  installmentPlansV2: Array<InstallmentPlan>;
  /** Get merchants multipay configuration */
  merchantsConfiguration: Array<MultiPayConfiguration>;
  /** Get monthly charges_breakdown by bill id */
  monthlyChargesBreakdownByBillId: MonthlyCharges;
  /** Get a multipay contract by multipay contract id */
  multipayContract: MultipayContract;
  /** Get multipay contracts */
  multipayContracts: Array<MultipayContract>;
  /** Get the consumer's PayNow payable amount */
  payableAmount: PayableAmount;
  /** Get a payment by ID for a consumer */
  payment: Payment;
  /** Get all payments for a consumer filtered by tier */
  payments: Array<Payment>;
  /**
   * Get all plus charges for a consumer. A plus charge is a charge with charge.tier == PLUS and charge.pushed_at > end of the current month
   * NOTE: Cannot fetch 'payment' subquery as the payments/captures are never fetched.
   */
  plusCharges: Array<Charge>;
  /** Get a plus contract by payment id */
  plusContract: PlusContract;
  /** Get all plus contracts */
  plusContracts: Array<PlusContract>;
  /** Get PayNow settlement breakdown */
  settlementBreakdown: SettlementBreakdown;
  /** Get PayNow settlement preview */
  settlementPreview: SettlementPreview;
  /** Get a consumer's spend limit */
  spendLimit?: Maybe<SpendLimit>;
  /** Get transaction by id */
  transaction: Transaction;
};

export type QueryKYCOCRResultsArgs = {
  applicantId: Scalars['String'];
};

export type QueryactiveSettlementMethodArgs = {
  billingCycle: Scalars['String'];
};

export type QuerybillStatementArgs = {
  id: Scalars['String'];
};

export type QuerybillStatementsArgs = {
  maxChargePerBill?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<BillStatementStatus>;
};

export type QuerychargeArgs = {
  id: Scalars['String'];
};

export type QuerychargesArgs = {
  from?: InputMaybe<Scalars['DateTimeUtc']>;
  kind?: InputMaybe<ChargeKind>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['DateTimeUtc']>;
};

export type QueryconsumerArgs = {
  masked?: InputMaybe<Scalars['Boolean']>;
};

export type QueryinstallmentPlanArgs = {
  id: Scalars['String'];
};

export type QueryinstallmentPlansV2Args = {
  dueDateAfter?: InputMaybe<Scalars['String']>;
  kinds?: InputMaybe<Array<InstallmentPlanKind>>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InstallmentPlanStatus>>;
};

export type QuerymerchantsConfigurationArgs = {
  merchantIds: Array<InputMaybe<Scalars['String']>>;
};

export type QuerymonthlyChargesBreakdownByBillIdArgs = {
  billStatementId: Scalars['String'];
};

export type QuerymultipayContractArgs = {
  id: Scalars['String'];
};

export type QuerymultipayContractsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<MultipayContractStatus>>;
};

export type QuerypaymentArgs = {
  id: Scalars['String'];
};

export type QuerypaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tier?: InputMaybe<Tier>;
};

export type QueryplusChargesArgs = {
  start?: InputMaybe<Scalars['NaiveDateTime']>;
};

export type QueryplusContractArgs = {
  id: Scalars['String'];
};

export type QueryplusContractsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QuerysettlementBreakdownArgs = {
  settlementChargeId: Scalars['String'];
};

export type QuerytransactionArgs = {
  id: Scalars['String'];
};

export type Reduction = {
  __typename?: 'Reduction';
  amount: Scalars['Float'];
  reductionType: ReductionType;
};

export enum ReductionType {
  CARRIER_DISCOUNT = 'CARRIER_DISCOUNT',
  DISCOUNT = 'DISCOUNT',
  DOWN_PAYMENT = 'DOWN_PAYMENT',
  TRADE_IN = 'TRADE_IN',
}

export type ReferenceIds = {
  currentChargesIds: Array<Scalars['String']>;
  outstandingBillId?: InputMaybe<Scalars['String']>;
  outstandingChargesIds: Array<Scalars['String']>;
  overdueBillsIds: Array<Scalars['String']>;
};

export enum RentOrMortgage {
  NO = 'NO',
  YES = 'YES',
}

export enum SelfEmailType {
  KYC_DROPOFF_SURVEY = 'KYC_DROPOFF_SURVEY',
}

export type SettlementBreakdown = {
  __typename?: 'SettlementBreakdown';
  currentUsageCharges: MonthlyCharges;
  outstandingBillStatementCharges: MonthlyCharges;
  overdueBillStatements: Array<PaidOverdueBillStatement>;
  postSettlementCharges: Array<MonthlyCharges>;
};

export type SettlementMethod = {
  __typename?: 'SettlementMethod';
  settlementPeriodEnd: Scalars['String'];
  status: SettlementMethodStatus;
};

export enum SettlementMethodStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SettlementMethodStatusChangeResult {
  APPLIED = 'APPLIED',
  CONFLICT = 'CONFLICT',
}

export type SettlementMethods = {
  __typename?: 'SettlementMethods';
  autoDebit: AutoDebitSettlementMethod;
  combini: SettlementMethod;
  van: SettlementMethod;
};

export type SettlementPreview = {
  __typename?: 'SettlementPreview';
  combiniFee: Scalars['Float'];
  currentUsageCharges: MonthlyCharges;
  isSettlementAvailable: Scalars['Boolean'];
  outstandingBillStatementCharges: MonthlyCharges;
  outstandingBillStatementId?: Maybe<Scalars['String']>;
  overdueBillStatements: Array<OverdueBillStatement>;
  payableAmount: Scalars['Float'];
};

export type SpendLimit = {
  __typename?: 'SpendLimit';
  max: Scalars['Float'];
  selected: Scalars['Float'];
};

export type SummaryPlus = {
  __typename?: 'SummaryPlus';
  balanceRatios: BalanceRatiosPlus;
  monthlyPower: Scalars['Float'];
  nextMonthDue: Scalars['Float'];
  payableAmount: Scalars['Float'];
};

export enum Tier {
  CLASSIC = 'CLASSIC',
  DIGITAL = 'DIGITAL',
  PLUS = 'PLUS',
}

export type TotalMonthUsage = {
  __typename?: 'TotalMonthUsage';
  billingCycle: Scalars['String'];
  usage: Scalars['Float'];
};

export type Transaction = {
  __typename?: 'Transaction';
  failureUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items: Array<TransactionItem>;
  pendingUrl?: Maybe<Scalars['String']>;
  returnUrl?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  successUrl?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Float'];
};

export type TransactionItem = {
  __typename?: 'TransactionItem';
  clawbackType?: Maybe<ClawbackType>;
  color?: Maybe<Scalars['String']>;
  currency: Currency;
  iconImage2x?: Maybe<Scalars['String']>;
  iconImage3x?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemKind: ItemKind;
  model?: Maybe<Scalars['String']>;
  monthlyAmount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  planDuration?: Maybe<Scalars['Float']>;
  reductions?: Maybe<Array<Reduction>>;
  serialNumber?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
  warrantyAmount?: Maybe<Scalars['Float']>;
};

export enum TransactionStatus {
  ASSESSMENT_UNAVAILABLE = 'ASSESSMENT_UNAVAILABLE',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  DECLINED_BALANCE_INSUFFICIENT = 'DECLINED_BALANCE_INSUFFICIENT',
  DECLINED_CREDIT_HISTORY_INSUFFICIENT = 'DECLINED_CREDIT_HISTORY_INSUFFICIENT',
  DECLINED_FRAUD = 'DECLINED_FRAUD',
  DECLINED_OVERDUE_BILL = 'DECLINED_OVERDUE_BILL',
  PENDING = 'PENDING',
  WITHDRAWN = 'WITHDRAWN',
}

export type TransactionStatusResponse = {
  __typename?: 'TransactionStatusResponse';
  status: TransactionStatus;
};

export type UnavailableInstallmentPlanOptions = {
  __typename?: 'UnavailableInstallmentPlanOptions';
  kind: InstallmentPlanKind;
  reason: UnavailableInstallmentPlanReason;
};

export type UnavailableInstallmentPlanReason = {
  __typename?: 'UnavailableInstallmentPlanReason';
  code: Scalars['String'];
  details: UnavailableInstallmentPlanReasonDetails;
  threshold?: Maybe<Scalars['Float']>;
};

export type UnavailableInstallmentPlanReasonDetails = {
  __typename?: 'UnavailableInstallmentPlanReasonDetails';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTimeUtc']>;
  currency?: Maybe<Currency>;
  installments?: Maybe<Array<Installment>>;
  kind?: Maybe<InstallmentPlanKind>;
  paymentId?: Maybe<Scalars['String']>;
};

export type UpdatePushPreferenceResponse = {
  __typename?: 'UpdatePushPreferenceResponse';
  category: MessagingHubPushNotificationCategory;
  enabled: Scalars['Boolean'];
};

export type VAN = {
  __typename?: 'VAN';
  accountHolder: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  branchName: Scalars['String'];
};

export type XPayKind = {
  __typename?: 'XPayKind';
  installmentCount: Scalars['Float'];
  kind: InstallmentPlanKind;
  threshold: Scalars['Float'];
};
